import { createQueryHook } from '../internal/createQueryHook';
import { applications } from '../queries/applications';

/**
 * @deprecated Use `applications.detail()._ctx.versionCount()` with `useQuery` directly.
 */
export const useApplicationVersionCount = createQueryHook(
  ({ applicationKey, params }: { applicationKey: string; params: { supported: boolean } }) =>
    applications.detail({ applicationKey })._ctx.versionCount({ params }),
);
